
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { ContactFormValues } from "./ContactFormSchema";

interface ContactPhoneFieldProps {
  form: UseFormReturn<ContactFormValues>;
}

export function ContactPhoneField({ form }: ContactPhoneFieldProps) {
  return (
    <FormField
      control={form.control}
      name="phone"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Phone Number</FormLabel>
          <FormControl>
            <Input placeholder="+1 (555) 123-4567" {...field} />
          </FormControl>
          <FormDescription>Optional</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
